<template>
  <div class="alignment">
    <!-- <v-btn class="right" color="blue" > Modifica </v-btn>
    <v-btn class="right" color="red"  > Cancella </v-btn>-->

    <template>
      <v-layout row wrap>
        <v-flex xs6 class="text-xs-left">
          <h3 class="styleHeader">
            {{ $t("pages.UserExtraction.Index.MappaturaUtenteEstrazione") }}
          </h3>
        </v-flex>
        <v-flex>
          <v-btn
            class="right white--text styleHeader styleAlignamentAddButton"
            :to="$i18nRoute({ name: 'UsersExtractionCreate' })"
            color="#279947"
          >
            <v-icon left>add</v-icon>
            {{ $t("pages.UserExtraction.Index.Aggiungi") }}
          </v-btn>
        </v-flex>
      </v-layout>
      <v-data-table
        :headers="[
          {
            text: this.currentLanguage.t('pages.UserExtraction.Index.Utente'),
            value: 'UserId'
          },
          {
            text: this.currentLanguage.t(
              'pages.UserExtraction.Index.DescEstrazione'
            ),
            value: 'ExtractionId'
          },
          { text: '' },
          { text: '' }
        ]"
        :items="usersExtractions"
        class="elevation-1"
      >
        <template v-slot:items="props">
          <td>{{ props.item.Nome }} {{ props.item.Cognome }}</td>
          <td>{{ props.item.Name }}</td>
          <td>
            <v-btn flat icon class="right" @click="editItem(props.item)">
              <v-icon>edit</v-icon>
            </v-btn>
          </td>
          <td>
            <v-btn flat icon class="right" @click="confirm(props.item)">
              <v-icon>delete</v-icon>
            </v-btn>
          </td>
        </template>
      </v-data-table>
      <v-alert
        class="centerButton"
        :value="conferma"
        transition="scale-transition"
      >
        {{ $t("pages.UserExtraction.Index.ConfermaElimina") }}
        <v-btn @click="deleteItem()">
          {{ $t("pages.UserExtraction.Index.Conferma") }}
        </v-btn>
        <v-btn @click="conferma = !conferma">
          {{ $t("pages.UserExtraction.Index.Annulla") }}
        </v-btn>
      </v-alert>
    </template>
  </div>
</template>

<script>
import usersExtractionsApi from "../../apiSmartLogistics/usersextractionsApi.js";
import router from "@/router/index.js";

import { Trans } from "@/plugins/Translation";
export default {
  data() {
    return {
      conferma: false,
      sUserExtraction: {},
      headers: [],
      usersExtractions: [],
      refreshMenu: ""
    };
  },

  computed: {
    currentLanguage() {
      return Trans.i18n;
    }
  },
  methods: {
    creating() {
      usersExtractionsApi.GetViewUsersExtractions().then(response => {
        this.usersExtractions = response.data;
      });
    },

    confirm(selectedUserExtraction) {
      this.sUserExtraction = selectedUserExtraction;
      this.conferma = true;
    },

    deleteItem() {
      usersExtractionsApi
        .DeleteViewUsersExtractions(this.sUserExtraction.Id)
        .then(() => {
          //console.log(response);
          this.conferma = false;
          this.$emit("refreshMenu", this.refreshMenu);
          this.creating();
        });
    },

    editItem(item) {
      router.push({ name: "UsersExtractionCreate", params: { Id: item.Id } });
    }
  },

  created() {
    this.creating();
  }
};
</script>
